module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/november-73a3c77f6f18a7d6f7798b17971edafa.png";